
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { Validate } from '@/types';
import DiscountInfo from '@/components/advanced/DiscountInfo.vue';

@Component<PromoSettings>({
	components: {
		ValidationObserver,
		DiscountInfo
	}
})
export default class PromoSettings extends Vue {
	@Prop({ type: Object, required: true }) private restaurant!: Restaurant;
	@Watch('restaurant')
	private onRestaurantChange(): void {
		this.setDiscount();
	}

	$refs!: { observer: Validate };

	// Discount
	private discountEnabled: boolean = false;
	private discountInfo: DiscountInfo|any = null;

	private created(): void {
		this.setDiscount();
	}

	/**
	 * Set discount info depending on if null or not
	 *
	 * @return {void}
	 */
	private setDiscount(): void {
		this.discountInfo = cloneDeep(this.restaurant.discount);

		if (this.discountInfo && this.discountInfo.codes && this.discountInfo.codes.length) {
			this.discountEnabled = true;

			this.discountInfo.codes.forEach((code: DiscountInfoCodes) => {
				code.value = code.value.slice(0, -1);
			});
		}
		else {
			this.discountEnabled = false;
			this.discountInfo = {};
		}
	}

	/**
	 * Save the promo settings
	 * Is called by Settings.vue when the save button is clicked
	 *
	 * @return {Promise<void>}
	 */
	public async save(): Promise<void> {
		const isValid = await this.$refs.observer.validate();
		if (isValid) {
			const updatedRestaurant = {
				...this.restaurant,
				discount: this.discountInfo
			};
			this.$emit('save-promo', updatedRestaurant);
		}
	}

	/**
	 * Update discount info from event
	 *
	 * @param {any} discountObject
	 * @return {void}
	 */
	private updateDiscountInfo(discountObject: any): void {
		this.discountEnabled = discountObject.enabled;
		this.discountInfo = discountObject.info;
	}
}
